module.exports = __webpack_public_path__ + "static/img/jt-20251226.5ae8342.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/jt-20251226.png
// module id = tYd4
// module chunks = 1